/* Shared unicare-product-reels controller; per-instance values are supplied by JSON configuration. */
(function () {
  if (window.UnicareProductReels) return;
  function mount(sectionId, elementId, rootUrl) {
(function () {
    function initUnicareReels() {
    var section = document.getElementById(elementId);
    if (!section || section.dataset.loaded === 'true') return;
    section.dataset.loaded = 'true';

    var shopifySection = section.closest('.shopify-section');
    var track = section.querySelector('[data-pr-track]');
    var prev = section.querySelector('[data-pr-prev]');
    var next = section.querySelector('[data-pr-next]');
    var modal = section.querySelector('[data-pr-modal]');
    var closeBtn = section.querySelector('[data-pr-close]');
    var overlay = section.querySelector('[data-pr-overlay]');
    var soundBtn = section.querySelector('[data-pr-sound]');
    var modalPrev = section.querySelector('[data-pr-modal-prev]');
    var modalNext = section.querySelector('[data-pr-modal-next]');
    var progressBar = section.querySelector('[data-pr-progress]');
    var progressTrack = section.querySelector('.unicare-pr-progress-track');
    var flashIcon = section.querySelector('[data-pr-flash]');
    var buyBtn = section.querySelector('[data-pr-buy-now]');
    var buyError = section.querySelector('[data-pr-buy-error]');

    var currentIndex = 0;
    var totalPanels = section.querySelectorAll('[data-pr-panel]').length;
    // Sound starts ON automatically on click (Watch & Shop interactive reels experience)
    var isMuted = false;
    var isUserHovering = false;
    var previousOverflow = '';
    var lastFocusedElement = null;
    var activeModalVideo = null;
    var prVideoObserver = null;
    var currentlyPlayingVideo = null;
    var pageActive = !document.hidden;
    var sectionUnloaded = false;
    var playbackEpoch = 0;
    var hoverTimers = [];
    var midFrameObserver = null;
    var midFrameBindings = [];
    var reelAnimations = [];
    var finishReelTransition = null;

    function clearReelTransition() {
      reelAnimations.forEach(function (animation) {
        animation.onfinish = null;
        animation.cancel();
      });
      reelAnimations = [];
      if (finishReelTransition) finishReelTransition();
      finishReelTransition = null;
    }

    // Seek only nearby, paused card previews; the modal keeps its own 0:00 player.
    function showMiddleFrame(video) {
      if (!video || !video.hasAttribute('data-pr-midframe') || !video.paused ||
          sectionUnloaded || currentlyPlayingVideo === video ||
          !Number.isFinite(video.duration) || video.duration <= 0) return;
      try { video.currentTime = video.duration / 2; } catch (error) {}
    }

    section.querySelectorAll('video[data-pr-midframe]').forEach(function (video) {
      function onMetadata() { showMiddleFrame(video); }
      function onSeeked() {
        if (video.paused && Math.abs(video.currentTime - video.duration / 2) < 0.25) {
          // A paused seek alone does not reliably replace the browser's poster.
          // Save the decoded frame as a real poster before resetting playback.
          if (!video.videoWidth || !video.videoHeight) return;
          try {
            var canvas = document.createElement('canvas');
            canvas.width = Math.min(600, video.videoWidth);
            canvas.height = Math.round(video.videoHeight * canvas.width / video.videoWidth);
            var context = canvas.getContext('2d');
            if (!context) return;
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            video.setAttribute('poster', canvas.toDataURL('image/jpeg', 0.85));
          } catch (error) {
            // Cross-origin media without CORS keeps the original Shopify poster.
          }
        }
      }
      function prepareMiddleFrame() {
        if (video.dataset.src) {
          video.preload = 'metadata';
          video.src = video.dataset.src;
          video.removeAttribute('data-src');
          video.load();
        } else {
          showMiddleFrame(video);
        }
      }
      video.addEventListener('loadedmetadata', onMetadata);
      video.addEventListener('seeked', onSeeked);
      midFrameBindings.push(function () {
        video.removeEventListener('loadedmetadata', onMetadata);
        video.removeEventListener('seeked', onSeeked);
      });
      video._prepareMiddleFrame = prepareMiddleFrame;
    });
    if ('IntersectionObserver' in window) {
      midFrameObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || sectionUnloaded) return;
          entry.target._prepareMiddleFrame();
          midFrameObserver.unobserve(entry.target);
        });
      }, { rootMargin: '200px', threshold: 0 });
      section.querySelectorAll('video[data-pr-midframe]').forEach(function (video) {
        midFrameObserver.observe(video);
      });
    }

    function pauseSectionPlayback() {
      clearReelTransition();
      playbackEpoch++;
      isUserHovering = false;
      hoverTimers.forEach(clearTimeout);
      hoverTimers = [];
      section.querySelectorAll('video').forEach(function (video) { video.pause(); });
      section.querySelectorAll('.unicare-pr-card').forEach(function (card) {
        card.classList.remove('is-hover-playing');
      });
      currentlyPlayingVideo = null;
    }

    function onPageInactive() {
      pageActive = false;
      pauseSectionPlayback();
    }
    function onPageActive() {
      pageActive = !document.hidden;
      // Never resume audible playback automatically when returning to the page.
    }
    function onVisibilityChange() {
      if (document.hidden) onPageInactive();
      else onPageActive();
    }
    document.addEventListener('visibilitychange', onVisibilityChange);
    window.addEventListener('blur', onPageInactive);
    window.addEventListener('focus', onPageActive);
    window.addEventListener('pagehide', onPageInactive);
    window.addEventListener('pageshow', onPageActive);

    function updateSoundIcons() {
      if (!soundBtn) return;
      var mutedIcon = soundBtn.querySelector('[data-icon-muted]');
      var soundIcon = soundBtn.querySelector('[data-icon-sound]');
      if (isMuted) {
        if (mutedIcon) mutedIcon.style.display = 'block';
        if (soundIcon) soundIcon.style.display = 'none';
        soundBtn.setAttribute('aria-label', 'Unmute audio');
      } else {
        if (mutedIcon) mutedIcon.style.display = 'none';
        if (soundIcon) soundIcon.style.display = 'block';
        soundBtn.setAttribute('aria-label', 'Mute audio');
      }
    }

    function stopAllVideos(preserveFrame) {
      if (!modal) return;
      playbackEpoch++;
      modal.querySelectorAll('video').forEach(function (v) {
        try {
          v.pause();
          if (v !== preserveFrame) v.currentTime = 0;
        } catch (e) {}
      });
      if (progressBar) progressBar.style.width = '0%';
      if (progressTrack) progressTrack.setAttribute('aria-valuenow', '0');
    }

    function showFlash() {
      if (!flashIcon) return;
      flashIcon.classList.add('is-active');
      setTimeout(function () {
        flashIcon.classList.remove('is-active');
      }, 400);
    }

    function playQuietly(video, allowMutedFallback) {
      if (!pageActive || document.hidden || sectionUnloaded) return;
      var epoch = playbackEpoch;
      try {
        var playback = video.play();
        if (playback && typeof playback.catch === 'function') playback.catch(function (error) {
          // A pending play can reject after blur, closing or switching reels.
          // Never let that stale rejection restart the old video.
          if (!allowMutedFallback || (error && error.name === 'AbortError') ||
              epoch !== playbackEpoch || !pageActive || document.hidden || sectionUnloaded ||
              modal.hidden || activeModalVideo !== video) return;
          video.muted = true;
          isMuted = true;
          updateSoundIcons();
          playQuietly(video);
        });
      } catch (error) {}
    }

    // Native no-poster players also obey background pause and single-video playback.
    function onVideoPlay(event) {
      var video = event.target;
      if (!video || video.tagName !== 'VIDEO') return;
      if (!pageActive || document.hidden || sectionUnloaded ||
          (!modal.hidden && !modal.contains(video)) ||
          (modal.contains(video) && (modal.hidden || activeModalVideo !== video))) { video.pause(); return; }
      section.querySelectorAll('video').forEach(function (other) {
        if (other !== video) other.pause();
      });
    }
    section.addEventListener('play', onVideoPlay, true);

    function playReelAtIndex(index) {
      if (totalPanels === 0) return;
      if (index < 0) return;
      if (index >= totalPanels) {
        closeModal();
        return;
      }
      clearReelTransition();
      var outgoingPanel = modal.querySelector('[data-pr-panel="' + currentIndex + '"]');
      var incomingPanel = modal.querySelector('[data-pr-panel="' + index + '"]');
      var direction = index > currentIndex ? 1 : -1;
      var animateSwipe = index !== currentIndex && outgoingPanel && !outgoingPanel.hidden &&
        incomingPanel && typeof incomingPanel.animate === 'function' &&
        window.matchMedia('(max-width: 749px)').matches &&
        !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var outgoingVideo = animateSwipe ? outgoingPanel.querySelector('video') : null;
      currentIndex = index;

      stopAllVideos(outgoingVideo);
      if (buyError) buyError.hidden = true;

      modal.querySelectorAll('[data-pr-panel]').forEach(function (panel) {
        var pIdx = parseInt(panel.getAttribute('data-pr-panel'), 10);
        panel.hidden = pIdx !== currentIndex && !(animateSwipe && panel === outgoingPanel);
      });

      if (animateSwipe) {
        var timing = { duration: 280, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' };
        finishReelTransition = function () {
          outgoingPanel.hidden = true;
          if (outgoingVideo) {
            try { outgoingVideo.currentTime = 0; } catch (error) {}
          }
        };
        reelAnimations = [
          outgoingPanel.animate([
            { transform: 'translateY(0)' },
            { transform: 'translateY(' + (-direction * 100) + '%)' }
          ], timing),
          incomingPanel.animate([
            { transform: 'translateY(' + (direction * 100) + '%)' },
            { transform: 'translateY(0)' }
          ], timing)
        ];
        reelAnimations[1].onfinish = clearReelTransition;
      }

      var activePanel = modal.querySelector('[data-pr-panel="' + currentIndex + '"]');
      if (activePanel) {
        var video = activePanel.querySelector('video');
        if (video) {
          activeModalVideo = video;
          if (video.dataset.modalPoster && !video.getAttribute('poster')) {
            video.setAttribute('poster', video.dataset.modalPoster);
          }
          if (video.dataset.modalSrc && (!video.src || video.src === '')) {
            video.src = video.dataset.modalSrc;
            video.load();
          }
          video.muted = isMuted;

          // Always start from the very beginning (0:00) on click
          try {
            video.currentTime = 0;
          } catch (e) {}
          video.addEventListener('loadedmetadata', function onMeta() {
            try { video.currentTime = 0; } catch (e) {}
            video.removeEventListener('loadedmetadata', onMeta);
          });

          video.ontimeupdate = function () {
            if (progressBar && video.duration) {
              var pct = Math.round((video.currentTime / video.duration) * 100);
              progressBar.style.width = pct + '%';
              if (progressTrack) progressTrack.setAttribute('aria-valuenow', String(pct));
            }
          };

          playQuietly(video, true);
        }
      }
    }

    function openModal(index) {
      if (!modal) return;
      lastFocusedElement = document.activeElement;
      previousOverflow = document.documentElement.style.overflow || '';

      // Unmute audio automatically on click
      isMuted = false;

      section.classList.add('is-modal-open');
      if (shopifySection) {
        shopifySection.style.position = 'relative';
        shopifySection.style.zIndex = '1200';
      }

      pauseSectionPlayback();
      // Pause, reset and mute preview slider videos
      section.querySelectorAll('.unicare-pr-track video').forEach(function (v) {
        try {
          v.pause();
          v.currentTime = 0;
          v.muted = true;
        } catch (e) {}
        var c = v.closest('.unicare-pr-card');
        if (c) c.classList.remove('is-hover-playing');
      });

      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';

      updateSoundIcons();
      playReelAtIndex(parseInt(index, 10) || 0);

      if (closeBtn) {
        setTimeout(function () { closeBtn.focus(); }, 60);
      }
    }

    function closeModal() {
      if (!modal) return;
      clearReelTransition();
      stopAllVideos();
      modal.hidden = true;
      section.classList.remove('is-modal-open');
      if (shopifySection) {
        shopifySection.style.position = '';
        shopifySection.style.zIndex = '';
      }
      document.documentElement.style.overflow = previousOverflow;

      if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
        lastFocusedElement.focus();
      }
    }

    var swipeStart = null;
    var suppressVideoClickUntil = 0;
    function onReelTouchStart(event) {
      swipeStart = null;
      if (modal.hidden || totalPanels < 1 ||
          !window.matchMedia('(max-width: 749px)').matches ||
          event.touches.length !== 1 ||
          !event.target.closest('.unicare-pr-modal-video-wrap')) return;
      swipeStart = { x: event.touches[0].clientX, y: event.touches[0].clientY };
    }
    function onReelTouchEnd(event) {
      var start = swipeStart;
      swipeStart = null;
      if (!start || !event.changedTouches.length || modal.hidden) return;
      var dx = event.changedTouches[0].clientX - start.x;
      var dy = event.changedTouches[0].clientY - start.y;
      var delta = Math.abs(dy) >= Math.abs(dx) ? dy : dx;
      if (Math.abs(delta) < 60) return;
      suppressVideoClickUntil = Date.now() + 500;
      playReelAtIndex(currentIndex + (delta < 0 ? 1 : -1));
    }
    function cancelReelTouch() { swipeStart = null; }
    modal.addEventListener('touchstart', onReelTouchStart, { passive: true });
    modal.addEventListener('touchend', onReelTouchEnd, { passive: true });
    modal.addEventListener('touchcancel', cancelReelTouch);

    // Toggle Play/Pause or Restart on Video Click
    modal.addEventListener('click', function (e) {
      if (e.target.closest('.unicare-pr-modal-video')) {
        if (Date.now() < suppressVideoClickUntil) return;
        var v = e.target.closest('.unicare-pr-modal-video');
        if (v.ended) {
          try { v.currentTime = 0; } catch (err) {}
          playQuietly(v);
        } else if (v.paused) {
          playQuietly(v);
        } else {
          v.pause();
        }
        showFlash();
      }
    });

    // Sound toggle
    if (soundBtn) {
      soundBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        isMuted = !isMuted;
        updateSoundIcons();
        if (activeModalVideo) {
          activeModalVideo.muted = isMuted;
        }
      });
    }

    // Modal Prev / Next
    if (modalPrev) {
      modalPrev.addEventListener('click', function (e) {
        e.stopPropagation();
        playReelAtIndex(currentIndex - 1);
      });
    }
    if (modalNext) {
      modalNext.addEventListener('click', function (e) {
        e.stopPropagation();
        playReelAtIndex(currentIndex + 1);
      });
    }


    // True Buy Now Handler (Direct checkout permalink for ONLY this variant, preserving existing cart untouched)
    if (buyBtn) {
      buyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var variantId = buyBtn.getAttribute('data-variant-id');
        if (!variantId) return;

        var textSpan = buyBtn.querySelector('span');
        var originalText = textSpan ? textSpan.textContent : 'BUY NOW';
        if (textSpan) textSpan.textContent = 'CHECKOUT...';
        buyBtn.disabled = true;
        if (buyError) {
          buyError.hidden = true;
          buyError.textContent = '';
        }

        var root = rootUrl;
        if (!root.endsWith('/')) root += '/';
        var directCheckoutUrl = root + 'cart/' + variantId + ':1';

        var isThemeEditor = Boolean(
          (window.Shopify && window.Shopify.designMode) ||
          (window.self !== window.top)
        );

        if (isThemeEditor) {
          window.open(directCheckoutUrl, '_blank');
          setTimeout(function () {
            if (textSpan) textSpan.textContent = originalText;
            buyBtn.disabled = false;
          }, 800);
        } else {
          window.location.href = directCheckoutUrl;
        }
      });
    }

    // Slider track arrows
    if (track && prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' });
      });
    }
    if (track && next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' });
      });
    }

    // Genuine desktop hover only; previews stay muted. Sound requires opening a reel.
    var cards = section.querySelectorAll('.unicare-pr-card');
    cards.forEach(function (card) {
      var video = card.querySelector('video.lazy-reel-video');
      if (!video || video.controls) return;
      var hoverTimer = null;

      card.addEventListener('mouseenter', function () {
        if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches ||
            !pageActive || document.hidden || sectionUnloaded || !modal.hidden) return;
        isUserHovering = true;
        var hoverEpoch = playbackEpoch;
        clearTimeout(hoverTimer);

        hoverTimer = setTimeout(function () {
          if (hoverEpoch !== playbackEpoch || !pageActive || document.hidden || sectionUnloaded || !modal.hidden) return;
          // Stop any other preview video playing
          cards.forEach(function (c) {
            if (c !== card) {
              c.classList.remove('is-hover-playing');
              var otherVid = c.querySelector('video.lazy-reel-video');
              if (otherVid) {
                try {
                  otherVid.pause();
                  if (currentlyPlayingVideo === otherVid) currentlyPlayingVideo = null;
                  showMiddleFrame(otherVid);
                  otherVid.muted = true;
                } catch (e) {}
              }
            }
          });

          if (video.dataset.src) {
            video.src = video.dataset.src;
            video.removeAttribute('data-src');
            video.load();
          }

          card.classList.add('is-hover-playing');
          try { video.currentTime = 0; } catch (e) {}
          currentlyPlayingVideo = video;

          video.muted = true;
          playQuietly(video);
        }, 160);
        hoverTimers.push(hoverTimer);
      });

      card.addEventListener('mouseleave', function () {
        isUserHovering = false;
        clearTimeout(hoverTimer);
        card.classList.remove('is-hover-playing');
        try {
          video.pause();
          video.muted = true;
          if (currentlyPlayingVideo === video) {
            currentlyPlayingVideo = null;
          }
          showMiddleFrame(video);
        } catch (e) {}
      });
    });

    // Card Open Trigger
    section.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-pr-open]');
      if (trigger) {
        e.preventDefault();
        openModal(trigger.getAttribute('data-modal-index'));
      }
    });

    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    if (overlay) overlay.addEventListener('click', closeModal);
    if (modal) {
      modal.addEventListener('click', function (e) {
        if (e.target === modal || e.target === overlay) {
          closeModal();
        }
      });
    }

    // Keyboard handling & WCAG Focus Trap
    function onKeyDown(e) {
      if (!document.contains(section)) {
        document.removeEventListener('keydown', onKeyDown);
        return;
      }
      if (!modal || modal.hidden) return;

      if (e.key === 'Escape') {
        closeModal();
        return;
      }
      if (e.key === 'ArrowLeft') {
        playReelAtIndex(currentIndex - 1);
        return;
      }
      if (e.key === 'ArrowRight') {
        playReelAtIndex(currentIndex + 1);
        return;
      }
      if (e.key === ' ') {
        if (activeModalVideo) {
          e.preventDefault();
          if (activeModalVideo.paused) playQuietly(activeModalVideo);
          else activeModalVideo.pause();
          showFlash();
        }
        return;
      }

      if (e.key === 'Tab') {
        var raw = modal.querySelectorAll('button:not([disabled]), [href], [tabindex]:not([tabindex="-1"])');
        var focusable = Array.prototype.filter.call(raw, function (el) {
          return !el.hidden && !el.closest('[hidden]') && el.offsetParent !== null;
        });
        if (focusable.length > 0) {
          var first = focusable[0];
          var last = focusable[focusable.length - 1];
          if (e.shiftKey && (document.activeElement === first || !modal.contains(document.activeElement))) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && (document.activeElement === last || !modal.contains(document.activeElement))) {
            e.preventDefault();
            first.focus();
          }
        }
      }
    }
    document.addEventListener('keydown', onKeyDown);

    // Single-most-visible preview autoplay on mobile/touch only
    // Desktop uses hover-preview only to preserve a calm, editorial PDP experience
    var prefersReducedMotion = Boolean(
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
    var isMobileViewport = Boolean(
      window.matchMedia && window.matchMedia('(max-width: 749px)').matches
    );

    if ('IntersectionObserver' in window && !prefersReducedMotion && isMobileViewport) {
      prVideoObserver = new IntersectionObserver(function (entries) {
        if (isUserHovering || !pageActive || document.hidden || sectionUnloaded || !modal.hidden) return;

        var bestEntry = null;
        var maxRatio = 0;

        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio > maxRatio) {
            maxRatio = entry.intersectionRatio;
            bestEntry = entry;
          }
        });

        if (bestEntry && bestEntry.intersectionRatio >= 0.6) {
          var targetVideo = bestEntry.target;
          if (currentlyPlayingVideo && currentlyPlayingVideo !== targetVideo) {
            try { currentlyPlayingVideo.pause(); } catch (e) {}
          }
          if (targetVideo.dataset.src) {
            targetVideo.src = targetVideo.dataset.src;
            targetVideo.removeAttribute('data-src');
            targetVideo.load();
          }
          targetVideo.muted = true;
          playQuietly(targetVideo);
          currentlyPlayingVideo = targetVideo;
        } else {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting && entry.target === currentlyPlayingVideo) {
              try { currentlyPlayingVideo.pause(); } catch (e) {}
              currentlyPlayingVideo = null;
            }
          });
        }
      }, { threshold: [0, 0.6, 1.0] });

      section.querySelectorAll('video.lazy-reel-video:not([controls]):not([data-pr-midframe]):not([data-pr-static-midframe])').forEach(function (v) {
        prVideoObserver.observe(v);
      });
    }

    function cleanupSection(event) {
      if (event.detail.sectionId !== sectionId) return;
      sectionUnloaded = true;
      pauseSectionPlayback();
      if (modal && !modal.hidden) closeModal();
      stopAllVideos();
      document.removeEventListener('visibilitychange', onVisibilityChange);
      window.removeEventListener('blur', onPageInactive);
      window.removeEventListener('focus', onPageActive);
      window.removeEventListener('pagehide', onPageInactive);
      window.removeEventListener('pageshow', onPageActive);
      section.removeEventListener('play', onVideoPlay, true);
      modal.removeEventListener('touchstart', onReelTouchStart);
      modal.removeEventListener('touchend', onReelTouchEnd);
      modal.removeEventListener('touchcancel', cancelReelTouch);
      if (prVideoObserver) prVideoObserver.disconnect();
      if (midFrameObserver) midFrameObserver.disconnect();
      midFrameBindings.forEach(function (remove) { remove(); });
      section.querySelectorAll('video[data-pr-midframe]').forEach(function (video) {
        delete video._prepareMiddleFrame;
      });
      document.removeEventListener('keydown', onKeyDown);
      document.removeEventListener('shopify:section:unload', cleanupSection);
      delete section.dataset.loaded;
    }
    document.addEventListener('shopify:section:unload', cleanupSection);
    }
    var reloadKey = 'unicare-reels-reload-' + sectionId;
    if (window[reloadKey]) document.removeEventListener('shopify:section:load', window[reloadKey]);
    window[reloadKey] = function(event) {
      if (event.detail.sectionId === sectionId) initUnicareReels();
    };
    document.addEventListener('shopify:section:load', window[reloadKey]);
    initUnicareReels();
  })();

  }
  window.UnicareProductReels = { mount: mount };
  function scan(scope) {
    if (!scope || !scope.querySelectorAll) return;
    scope.querySelectorAll('script[data-unicare-reels-config]').forEach(function (config) {
      if (config.dataset.controllerLoaded === 'true') return;
      try {
        var values = JSON.parse(config.textContent);
        config.dataset.controllerLoaded = 'true';
        mount(values.sectionId, values.elementId, values.rootUrl || '/');
      } catch (error) {
        console.warn('[Unicare] Invalid video section configuration', error);
      }
    });
  }
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); }, { once: true });
  } else {
    scan(document);
  }
})();
